/**
 * Starter words for the house rules, and the names of the kinds of thing a
 * wish can be.
 *
 * The rules text is a default, not a policy. A blank box asks a parent to
 * invent a spending philosophy on the spot, which is why most of them stay
 * blank — and a blank box means the child reads nothing at the moment they are
 * deciding whether to ask. Starter text that a family edits into their own
 * words gets the sentence written; the screen says plainly that changing it is
 * the expected thing to do.
 *
 * The kind labels are display-only, like every other vocabulary in this app
 * (CLAUDE.md, invariants): the domain speaks `toy` and `kit`, and no financial
 * value depends on which word appears above them.
 */

export const HOUSE_RULES_DEFAULT = `We buy things we'll still use in a month. We don't buy toys that break in a week.

Saving up for something bigger is always a yes: a build kit, a bike or scooter, an experience like ice skating or a trip.

Books, art supplies, and gifts for other people are always a yes.

Toys are fine sometimes. Ask, and we'll talk about it.`;

/** What each kind is called where a child reads it. */
export const KIND_LABEL = Object.freeze({
  kit: 'Build kit',
  experience: 'Experience',
  gear: 'Bigger thing',
  toy: 'Toy',
  gift: 'Gift for someone',
  other: 'Something else',
});

/**
 * One example each, for the kinds where the word alone is ambiguous. The three
 * empty strings are deliberate: "Toy" and "Gift for someone" explain
 * themselves, and an example under "Something else" would narrow the one
 * category that exists to be wide.
 */
export const KIND_HINT = Object.freeze({
  kit: 'KiwiCo, CrunchLabs',
  experience: 'Ice skating, a day out',
  gear: 'A bike, a scooter',
  toy: '',
  gift: '',
  other: '',
});
